
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import { h as hasSlot } from './labels-mixin.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import 'lodash/get';
import { f as PendoLoading } from './pendo-loading-mixin.js';
import 'element-ui/lib/form';
import 'element-ui/lib/form-item';
import 'element-ui/lib/input';
import 'element-ui/lib/input-number';
import 'lodash/debounce';
import './pendo-input-number.js';
import './pendo-input-autowidth.js';
import PendoEditableContent from './pendo-editable-content.js';

var script = {
  name: 'PendoPageHeader',
  components: {
    PendoEditableContent
  },
  directives: {
    PendoLoading
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: undefined
    },
    editable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      maxWidth: '100%',
      isWrapped: false,
      actionObserver: null,
      editableContentObserver: null
    };
  },

  computed: {
    hasActions() {
      return hasSlot(this, 'actions');
    },

    hasTop() {
      return hasSlot(this, 'top');
    },

    hasBottom() {
      return hasSlot(this, 'bottom');
    }

  },

  mounted() {
    this.setMaxWidth();

    if (this.hasActions) {
      this.initActionObserver();
    }

    if (this.editable) {
      this.initEditableContentObserver();
    }
  },

  beforeDestroy() {
    if (this.actionObserver) {
      this.actionObserver.disconnect();
      this.actionObserver = null;
    }

    if (this.editableContentObserver) {
      this.editableContentObserver.disconnect();
      this.editableContentObserver = null;
    }
  },

  methods: {
    setMaxWidth() {
      this.maxWidth = this.$refs.wrapper.clientWidth - 36 - this.$refs.tags.clientWidth;
    },

    initActionObserver() {
      this.actionObserver = new ResizeObserver(entries => {
        const actionsSlot = entries[0].target;
        this.isWrapped = actionsSlot.offsetTop > this.$refs.content.offsetTop;
      });
      this.actionObserver.observe(this.$refs.actions);
    },

    initEditableContentObserver() {
      this.editableContentObserver = new ResizeObserver(this.setMaxWidth.bind(this));
      this.editableContentObserver.observe(this.$refs.wrapper);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('header', {
    staticClass: "pendo-page-header",
    class: {
      'pendo-page-header--editable': _vm.editable,
      'is-wrapped': _vm.isWrapped
    }
  }, [_c('div', {
    ref: "wrapper",
    staticClass: "pendo-page-header__wrapper"
  }, [_vm._t("default", [_c('div', {
    ref: "content",
    staticClass: "pendo-page-header__content"
  }, [_vm.hasTop ? _c('div', {
    directives: [{
      name: "pendo-loading",
      rawName: "v-pendo-loading",
      value: {
        loading: _vm.loading,
        skeletonProps: {
          width: 400
        }
      },
      expression: "{ loading, skeletonProps: { width: 400 } }"
    }],
    staticClass: "pendo-page-header__top-wrapper"
  }, [_vm._t("top", [_vm.loading ? _c('div', [_vm._v("\n                             \n                        ")]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "pendo-loading",
      rawName: "v-pendo-loading",
      value: {
        loading: _vm.loading,
        skeletonProps: {
          width: 400,
          height: 44
        }
      },
      expression: "{ loading, skeletonProps: { width: 400, height: 44 } }"
    }],
    staticClass: "pendo-page-header__title-wrapper"
  }, [_vm.loading ? _c('h1', [_vm._v("\n                         \n                    ")]) : _vm._e(), _vm._v(" "), !_vm.loading ? _vm._t("title", [_vm.editable ? _c('pendo-editable-content', _vm._g(_vm._b({
    attrs: {
      "content-slot-class": "pendo-page-header__title",
      "auto-width": "",
      "max-width": _vm.maxWidth,
      "exit-event": "blur",
      "value": _vm.title
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('h1', {
          staticClass: "pendo-page-header__title"
        }, [_vm._v("\n                                    " + _vm._s(_vm.title) + "\n                                ")])];
      },
      proxy: true
    }], null, false, 2241033197)
  }, 'pendo-editable-content', _vm.$attrs, false), _vm.$listeners)) : _vm._e(), _vm._v(" "), !_vm.editable ? _c('h1', {
    staticClass: "pendo-page-header__title"
  }, [_vm._v("\n                            " + _vm._s(_vm.title) + "\n                        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "tags",
    staticClass: "pendo-page-header__tags"
  }, [_vm._t("tags")], 2)], 2), _vm._v(" "), _vm.hasBottom ? _c('div', {
    directives: [{
      name: "pendo-loading",
      rawName: "v-pendo-loading",
      value: {
        loading: _vm.loading,
        skeletonProps: {
          width: 400
        }
      },
      expression: "{ loading, skeletonProps: { width: 400 } }"
    }],
    staticClass: "pendo-page-header__bottom-wrapper"
  }, [_vm._t("bottom", [_vm.loading ? _c('div', [_vm._v("\n                             \n                        ")]) : _vm._e()])], 2) : _vm._e()]), _vm._v(" "), _vm.hasActions ? _c('div', {
    ref: "actions",
    staticClass: "pendo-page-header__actions-wrapper"
  }, [_vm._t("actions")], 2) : _vm._e()])], 2)]);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-page-header.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoPageHeader = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoPageHeader;
